<div class="flexRowParent"
     matAutocompleteOrigin
     #origin="matAutocompleteOrigin">
    <input type="text"
           #autocompleteInput
           matInput
           class="ac-single-select-input"
           [disabled]="ngDisabled | acFunc : validatorsService.isFieldDisabled : acInputContainerComponent?.isDisabled : acFormComponent?.isDisabled"
           [placeholder]="isLocationReady?null:loadingText"
           [matAutocomplete]="auto"
           [matAutocompleteConnectedTo]="origin"
           [ngModel]="addressValue"
           (ngModelChange)="modelChanged($event)">

    <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngIf="!isLocationReady" disabled>
            Fetching...
        </mat-option>

        <mat-option *ngIf="isLocationReady && (!locations || locations.length === 0)" disabled>
            No items found
        </mat-option>

        <ng-container *ngIf="isLocationReady && locations.length > 0">
            <mat-option *ngFor="let location of locations" (onSelectionChange)="locationSelected(location)"
                        [value]="location.display_name"
                        class="ac-geo-select-option">
            <span acLabel>
                {{location.display_name}}
            </span>
            </mat-option>
        </ng-container>
    </mat-autocomplete>
</div>
